import { Accordion } from 'components/v2/Accordion'
import { Row } from 'components/v2/Grid'
import { LinkComponent } from 'components/v2/Link'
import { Text } from 'components/v2/Text'

const FrequentlyQuestions = () => (
	<section id='frequently-questions'>
		<Row className='min-w-full flex-wrap bg-[#F9FAFD]'>
			<Row className='mx-auto max-w-[1200px] flex-wrap px-3 py-16'>
				<Row className='mb-10 min-w-full flex-wrap'>
					<Text
						as='h3'
						className='mb-3 text-base font-semibold text-gray-800 md:text-2xl'
					>
						Possui dúvidas?
					</Text>
					<Text variant='regular' className='text-gray-800'>
						Para iniciar sua jornada com segurança, reunimos respostas dos
						nossos especialistas sobre terapia online, uma alternativa que
						amplia o acesso ao cuidado psicológico para quem vive longe de
						grandes centros, mora fora do país ou busca mais autonomia no
						cuidado com a saúde mental.
						<br /> <br />A terapia online foi regulamentada no Brasil em
						12/11/2018, pela Resolução CFP 011/2018.
					</Text>
				</Row>
				<Row className='frequently-asked-questions mb-4 min-w-full flex-wrap'>
					<Accordion label='Quanto custa a terapia online?' className='mb-2'>
						<Text variant='small' className='text-gray-600'>
							Além da conveniência, a terapia online amplia o acesso. Na
							Vittude, as sessões podem custar a partir de R$50,00, dependendo
							do profissional. Colaboradores de empresas parceiras podem contar
							com subsídio parcial ou total do valor.
							<br /> <br />
							Preço não define competência. Muitos profissionais experientes
							atuam fora dos grandes centros e conseguem oferecer valores mais
							acessíveis, mantendo alto nível técnico.
						</Text>
					</Accordion>
					<Accordion label='Como funciona a terapia online?' className='mb-2'>
						<Text variant='small' className='text-gray-600'>
							A terapia online é uma das modalidades de cuidado psicológico que
							mais cresce no Brasil. Ela permite que você converse com seu
							psicólogo de onde estiver, em horários compatíveis com sua
							rotina.
							<br />
							<br />
							O atendimento ocorre por videoconferência, em ambiente seguro e
							sigiloso, usando computador ou smartphone, dentro do nosso site
							de terapia online estruturado para proteger seus dados.
						</Text>
					</Accordion>
					<Accordion
						label='E se eu não gostar do meu psicólogo?'
						className='mb-2'
					>
						<Text variant='small' className='text-gray-600'>
							Se não houver identificação com o profissional ou com a
							abordagem, a troca é possível e saudável. Você pode escolher
							outro psicólogo, usar novamente o Vittude Match ou falar com o
							time de suporte. O essencial é não interromper o cuidado.
							<br /> <br />
							Para o sucesso de uma sessão de terapia é importante haver
							sintonia entre você e seu psicólogo. É possível que, mesmo
							escolhendo um profissional muito experiente, você não se
							identifique com a metodologia ou mesmo com como a sessão ocorre.
							Se isso acontecer, saiba que uma possível falta de identificação
							não é falha sua nem do psicólogo.
							<br /> <br />
							Lembre-se: não desista da terapia se não curtir o psicólogo.
							Escolha um novo psicólogo e tente mais uma vez.
						</Text>
					</Accordion>
					<Accordion label='Vocês aceitam plano de saúde?' className='mb-2'>
						<Text variant='small' className='text-gray-600'>
							Os psicólogos da Vittude emitem recibos para solicitação de
							reembolso junto às operadoras de saúde. Basta solicitar após a
							sessão. Caso precise de apoio, nosso time está disponível para
							orientar durante o processo.
							<br />
							<br />
							Se precisar de ajuda para receber o reembolso, entre em contato
							com a sua operadora ou converse com nosso time de felicidade do
							cliente. Nossos colaboradores são treinados para cuidar com
							carinho e muita atenção de todos os nossos clientes.
						</Text>
					</Accordion>
					<Accordion
						label='A plataforma de terapia online da Vittude é segura?'
						className='mb-2'
					>
						<Text variant='small' className='text-gray-600'>
							Sim. A Vittude opera como plataforma de psicologia online com
							protocolos rigorosos de segurança da informação. Os dados são
							criptografados, o acesso é controlado e nenhuma sessão é gravada.
							O sigilo profissional é respeitado em todas as camadas da
							tecnologia e do atendimento.
						</Text>
					</Accordion>
					<Accordion
						label='Os psicólogos da Vittude são verificados?'
						className='mb-2'
					>
						<Text variant='small' className='text-gray-600'>
							Todos os profissionais passam por processo de validação
							documental, com registro ativo no CRP e análise de formação e
							experiência clínica. A Vittude mantém monitoramento contínuo para
							garantir conformidade ética e técnica.
						</Text>
					</Accordion>
					<Accordion
						label='A terapia online tem a mesma eficácia da presencial?'
						className='mb-2'
					>
						<Text variant='small' className='text-gray-600'>
							Estudos e diretrizes internacionais indicam que a terapia online
							apresenta resultados equivalentes à presencial para diversos
							quadros. O fator decisivo é a qualidade do vínculo terapêutico,
							não o meio. A Vittude estrutura tudo para ser a sua melhor
							plataforma de terapia online e favorecer essa relação com
							segurança e continuidade.
						</Text>
					</Accordion>
				</Row>
				<Row className='min-w-full flex-wrap justify-start'>
					<Text className='mb-2 w-full text-lg font-semibold text-gray-800'>
						Não encontrou o que procurava?
					</Text>
					<LinkComponent
						href='/faq'
						label='Veja mais respostas'
						variant='medium'
						icon={true}
						className='no-underline'
					/>
				</Row>
			</Row>
		</Row>
	</section>
)

export default FrequentlyQuestions
